type ModalError = "parallelEditError"; // add more errors as needed

export interface ErrorModalState {
  showModal: boolean;
  errorType: ModalError;
}

const ErrorModalStore = {
  namespaced: true,
  state: {
    showModal: false,
    errorType: "parallelEditError",
  } as ErrorModalState,
  mutations: {
    toggleErrorModal(
      state: ErrorModalState,
      data: {
        showModal: boolean;
        errorType?: ModalError;
      }
    ) {
      state.showModal = data.showModal;
      if (data.errorType) state.errorType = data.errorType;
    },
  },
  actions: {
    toggleErrorModal(
      {
        commit,
        state,
      }: {
        commit: (mutation: string, payload: any) => void;
        state: ErrorModalState;
      },
      modalType = { errorType: "parallelEditError" }
    ) {
      commit("toggleErrorModal", {
        showModal: !state.showModal,
        errorType: modalType?.errorType,
      });
    },
  },
};

export default ErrorModalStore;
